import type { ReactNode } from 'react';
import {
  IconCharge,
  IconDashboard,
  IconGateway,
  IconLadder,
  IconOptOut,
  IconProviders,
  IconQueue,
  IconUsers,
} from '../ui/components/icons.js';
import { Dashboard } from '../ui/pages/Dashboard.js';
import { Cobrancas } from '../ui/pages/Cobrancas.js';
import { Clientes } from '../ui/pages/Clientes.js';
import { Regua } from '../ui/pages/Regua.js';
import { Fila } from '../ui/pages/Fila.js';
import { Optout } from '../ui/pages/Optout.js';
import { Gateway } from '../ui/pages/Gateway.js';
import { Providers } from '../ui/pages/Providers.js';

export interface RouteDef {
  id: string;
  label: string;
  section: string;
  icon: (props: { size?: number }) => ReactNode;
  render: (nav: (id: string) => void) => ReactNode;
}

/**
 * Rotas do painel.
 *
 * Fonte única: a sidebar itera este array, o roteador casa pelo `id` e o header
 * pega o título aqui. Adicionar uma tela é acrescentar uma entrada — nada no
 * shell muda, o mesmo princípio do registro de comandos do backend.
 */
export const ROUTES: RouteDef[] = [
  { id: 'visao', label: 'Visão geral', section: 'Operação', icon: IconDashboard, render: (nav) => <Dashboard onNavigate={nav} /> },
  { id: 'cobrancas', label: 'Cobranças', section: 'Operação', icon: IconCharge, render: () => <Cobrancas /> },
  { id: 'clientes', label: 'Clientes', section: 'Operação', icon: IconUsers, render: () => <Clientes /> },
  { id: 'regua', label: 'Régua de cobrança', section: 'Cobrança', icon: IconLadder, render: () => <Regua /> },
  { id: 'fila', label: 'Fila de jobs', section: 'Cobrança', icon: IconQueue, render: () => <Fila /> },
  { id: 'optout', label: 'Opt-out', section: 'Cobrança', icon: IconOptOut, render: () => <Optout /> },
  { id: 'gateway', label: 'Gateway', section: 'Configuração', icon: IconGateway, render: () => <Gateway /> },
  { id: 'providers', label: 'Providers', section: 'Configuração', icon: IconProviders, render: () => <Providers /> },
];

export const ROTA_PADRAO = 'visao';

export function acharRota(id: string): RouteDef {
  return ROUTES.find((r) => r.id === id) ?? ROUTES[0]!;
}
